import React from 'react';
import { dictionary } from '../../../../dictionary';

const PersoReportTableFooter = ({ totalSums, styles }) => {
  return (
    <tfoot>
      <tr style={{ fontWeight: 'bold' }}>
        <td colSpan="4" style={styles.sumCell}>
          {dictionary.perso_table_sum}
        </td>
        <td style={styles.sumCell}>{totalSums.standardMonthlyHours.toString().replace('.', ',')}</td>
        <td style={styles.sumCell}>{totalSums.worked_hours.toString().replace('.', ',')}</td>
        <td style={styles.sumCell}>{totalSums.worked_days.toString().replace('.', ',')}</td>
        <td style={{ ...styles.sumCell, color: totalSums.overtime >= 0 ? 'green' : 'red' }}>
          {totalSums.overtime.toFixed(2).toString().replace('.', ',')}
        </td>
        <td style={styles.sumCell}>{totalSums.l4_hours.toString().replace('.', ',')}</td>
        <td style={styles.sumCell}>{totalSums.l4_days.toString().replace('.', ',')}</td>
        <td style={styles.sumCell}>{totalSums.special_hours.toFixed(2).toString().replace('.', ',')}</td>
        <td style={styles.sumCell}>{totalSums.special_days.toString().replace('.', ',')}</td>
        <td style={styles.sumCell}>{totalSums.childcare_hours.toString().replace('.', ',')}</td>
        <td style={styles.sumCell}>{totalSums.childcare_days.toFixed(2).toString().replace('.', ',')}</td>
        <td style={styles.sumCell}>{totalSums.vacation_hours.toString().replace('.', ',')}</td>
        <td style={styles.sumCell}>{totalSums.vacation_days.toString().replace('.', ',')}</td>
        <td style={styles.sumCell}>{totalSums.total_sum.toString().replace('.', ',')}</td>
      </tr>
      <tr style={{ fontWeight: 'bold' }}>
        <td colSpan="16" style={{ ...styles.sumCell, textAlign: 'left' }}>
          {dictionary.perso_table_sum_absence_hours}
        </td>
        <td style={styles.sumCell}>
          {(totalSums.l4_hours + totalSums.special_hours + totalSums.childcare_hours + totalSums.vacation_hours)
            .toFixed(2)
            .toString()
            .replace('.', ',')}
        </td>
      </tr>
      <tr style={{ fontWeight: 'bold' }}>
        <td colSpan="16" style={{ ...styles.sumCell, textAlign: 'left' }}>
          {dictionary.perso_table_sum_absence_days}
        </td>
        <td style={styles.sumCell}>
          {(totalSums.l4_days + totalSums.special_days + totalSums.childcare_days + totalSums.vacation_days)
            .toString()
            .replace('.', ',')}
        </td>
      </tr>
    </tfoot>
  );
};

export default PersoReportTableFooter;
